import treasuryKidsForm from './treasury-kids-form/treasury-kids-form.vue';
import treasuryKidsResult from './treasury-kids-result/treasury-kids-result.vue';
import { mapState, mapGetters } from 'vuex';
import messages from './treasury-kids.json';

export default {
	i18n: { messages },
	components: {
		treasuryKidsForm,
		treasuryKidsResult
	},
	computed: {
		...mapState('treasuryKids', ['displayNames', 'date']),
		...mapGetters('treasuryKids', ['filteredFiles'])
	},
	methods: {
		getFiles(day) {
			let lang = this.$i18n.locale.toUpperCase();
			this.$store.dispatch('treasuryKids/getFiles', { lang, day });
		}
	},
	created() {
		this.getFiles();
	}
};
